export default "__VITE_ASSET__GhXD69IZ__"